import React, { useState, useEffect } from 'react';
import { Col, Text, Row } from 'react-quick-style-components';
import { useNavFunc } from 'navigation';
import { IScreen } from 'type';
import { COLOR } from 'const';
import { Header, Footer } from 'components';
import { ActivityIndicator } from 'react-native';
import Store from 'store';

const CaskTransferDetail: IScreen = () => {
  const { route, navigate } = useNavFunc();
  const [{ email, firebaseUser, ready }] = Store.User.createStore();
  const [{ }, cApi] = Store.Client.createStore();
  const [previewUrl, setPreviewUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const id = route.params?.id;

  // Get presigned URL from API
  useEffect(() => {
    const fetchPreviewUrl = async () => {
      if (!ready || (!email && !firebaseUser)) {
        return;
      }
      
      setLoading(true);
      const [res, err] = await cApi.genAssetsLink({ id, type: 'esign' });
      
      if (err || !res || !res.data) {
        setError('Failed to load document');
        setLoading(false);
        return;
      }
      
      setPreviewUrl(res.data);
      setLoading(false);
    };
    
    if (id) {
      fetchPreviewUrl();
    }
  }, [id, email, firebaseUser, ready]);

  if (loading) {
    return (
      <Col flex1 center backgroundColor={COLOR.BG}>
        <Header />
        <Col flex1 center>
          <ActivityIndicator size="large" color={COLOR.PRIMARY} />
          <Text marginTop={20}>Loading document...</Text>
        </Col>
        <Footer />
      </Col>
    );
  }

  if (error) {
    return (
      <Col flex1 backgroundColor={COLOR.BG}>
        <Header />
        <Col flex1 center padding={30}>
          <Text fontSize={20} color="red" marginBottom={20}>{error}</Text>
          <Text 
            fontSize={16} 
            color={COLOR.PRIMARY}
            onPress={() => navigate('CaskTransferCompleted')}
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
          >
            Back to Documents
          </Text>
        </Col>
        <Footer />
      </Col>
    );
  }

  return (
    <Col flex1 backgroundColor={COLOR.BG}>
      <Header />
      <Col flex1 style={{ width: '100%', height: '100%', minHeight: 600 }}>
        <Row 
          center 
          paddingVertical={15} 
          paddingHorizontal={20}
          backgroundColor="white"
          style={{ borderBottom: '1px solid #e0e0e0' }}
        >
          <Text 
            fontSize={14} 
            color={COLOR.PRIMARY}
            onPress={() => navigate('CaskTransferCompleted')}
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
          >
            ← Back to Documents
          </Text>
          <Text flex1 center fontSize={16} bold>
            Cask Transfer Document #{id}
          </Text>
          <div style={{ width: 150 }} />
        </Row>
        <iframe
          src={previewUrl}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            flex: 1,
          }}
          title="Document Preview"
          key={previewUrl}
        />
      </Col>
      <Footer />
    </Col>
  );
};

CaskTransferDetail.routeInfo = {
  title: 'Cask Transfer Detail',
  path: '/documents/cask-transfer/detail/:id'
};

export default CaskTransferDetail;
